import { Box } from '@mantine/core';

import styles from './BodyContent.module.scss';

export function BodyContent({ children }: { children: React.ReactNode }): React.ReactNode {
	return <Box className={styles['bodyContent']}>{children}</Box>;
}
